/** Presentation only; travel authority and trigger bounds do not depend on this value. */
export type TeleporterVisualType = 'glow' | 'hologram' | 'road';

/** Unknown or absent authored presentation keeps the established portal appearance. */
export function resolveTeleporterVisualType(value: unknown): TeleporterVisualType {
  return value === 'road' || value === 'glow' ? value : 'hologram';
}
